import Loans from '../pages/Loans/Loans';
import Deposits from '../pages/Deposits/Deposits';
import Developers from '../pages/Developers/Developers';

export interface Page {
    path: string;
    Element: React.FC;
}

export const routes: Page[] = [
    {
        path: '/loans',
        Element: Loans,
    },
    {
        path: '/deposits',
        Element: Deposits,
    },
    {
        path: '/developers',
        Element: Developers,
    },
];
